import Choices from "choices.js";

export default class Global {

    constructor() {
        this.initChoices();
        this.disablePopup();
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }

    disablePopup() {
        if (getCookie('popupDisable') == 'true') {
            document.getElementById('popup').style.display = 'none';
        }

        const popup = document.getElementById('popup');
        if (popup) {
            const handleDisablePopup = () => {
                popup.classList.add("disable");

                const date = new Date();
                date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
                const expires = "expires=" + date.toUTCString();
                document.cookie = 'popupDisable=true; ' + expires;

                console.log(document.cookie);
                console.log(getCookie('popupDisable'));
            };

            const disablePopupButton = document.getElementById('disablePopupButton');
            const button = popup.querySelector('.button');

            if (disablePopupButton) {
                disablePopupButton.addEventListener("click", function (e) {
                    e.preventDefault();
                    handleDisablePopup();
                });
            }

            if (button) {
                button.addEventListener("click", function () {
                    handleDisablePopup();
                });
            }
        }

        function getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }
}
